<div class="d-inline-block" kbxlStopClickPropagation>
  <span class="copy" (click)="copyToClipboard()">
    <fa-icon [icon]="['fas', 'copy']" size="md"></fa-icon>
  </span>
</div>
